import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { queryBuilder } from '@metromarkets/sdk';
import { OrderHistoryItem } from '../models';
import { ApiConfig } from '~shared/constants/api.config';
import { PaginatedResponse } from '~shared/models';
import { BuyerAccountService } from '~core/modules/buyer-account';

@Injectable({
  providedIn: 'root',
})
export class OrdersHistoryService {
  constructor(
    private httpClient: HttpClient,
    private buyerAccountService: BuyerAccountService,
  ) {}

  fetchOrders(queryParams: Params): Observable<PaginatedResponse<OrderHistoryItem>> {

    const activeContext = queryParams.filter.activeContext
    let paramsV3 = { ...queryParams }
    delete paramsV3.filter.activeContext
    paramsV3 = queryBuilder.toParams(paramsV3)

    return this.httpClient.get<PaginatedResponse<OrderHistoryItem>>(ApiConfig.SVC_BUYER_GATEWAY_ORDERS_MANAGEMENT_URL_API_ENDPOINT_V3(), {
      params: { ...paramsV3 },
      headers: new HttpHeaders({
        'X-Active-Context': activeContext,
      }),
    });
  }

  cancelProduct(orderLineId: string): Observable<{}> {
    const url = `${ApiConfig.SVC_ORDER_MANAGEMENT_USER_ACCOUNT_API_ENDPOINT_V2()}/order-lines/${orderLineId}/cancel`;

    return this.httpClient.post<{}>(url, {});
  }

  getLinkToDocumentDownload(type: string, id: string) {
    return this.httpClient
      .post(`${ApiConfig.SVC_ORDER_MANAGEMENT_USER_ACCOUNT_API_ENDPOINT()}/documents/download-urls/${type}/${id}`, {});
  }

  getDocument(url: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/pdf',
      }),
      responseType: 'blob' as 'json',
    };
    return this.httpClient.get(url, httpOptions);
  }

  cancelOrder(orderId: string): Observable<{}> {
    const url = `${ApiConfig.SVC_ORDER_MANAGEMENT_USER_ACCOUNT_API_ENDPOINT_V2()}/orders/${orderId}/cancel`;

    return this.httpClient.post<{}>(url,{});
  }

  createSupportTicket(orderLineId: string): void {
    this.buyerAccountService.loginToSSO();
  }
}
